import { useState, useRef, useEffect } from "react";
import React from 'react'
import Jobs_header from '../Header/Jobs_header'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import "../../styles/Jobs.css"
import delete_icon from "../../assets/svg/delete_icon.svg";
import ReactPaginate from "react-paginate";
import axios from 'axios';
// import edit_icon from "../../assets/svg/edit-icon.svg";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import filterOpenCloseIcon from "../../assets/svg/filterOpenCloseIcon.svg";
import revert_icon from "../../assets/svg/revert_icon.svg";
import { ToastContainer, toast } from "react-toastify"
import Select from "react-select";
import AsyncSelect from "react-select/async";
import axiosInstance from "../../axiosInstance";
import { useSearchParams } from 'react-router-dom';
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";
import { components } from "react-select";
import { Eye } from 'lucide-react';
import plus_icon from "../../assets/svg/plus_icon.svg";
import AddExistingJob from "./AddAdditionalCharges/AddExistingJob";
import AddVendor from "./AddVendor";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import CommonFooter from "../../CommonFooter/CommonFooter";
import DraftCostInvoiceModal from "./DraftCostInvoiceModal";
import GenerateCostInvoiceModal from "./GenerateCostInvoiceModal";
import CommonPagination from "../../CommonPagination/CommonPagination";
import JobsFilter from "./JobsFilter";

const Jobs = () => {

    let ModuleId = 23
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);
    const [searchTerm, setSearchTerm] = useState('');
    const userType = localStorage.getItem("user_type");
    console.log("userTypeeeeeeeeeeeeeeeeeeeeeee", userType);
    const [selectedVendor, setSelectedVendor] = useState([]);
    const [editModal, setEditModal] = useState({
        isOpen: false,
        jobId: null,
        lineItem: null
    });
    const [vendorData, setVendorData] = useState(null);
    const [showFilters, setShowFilters] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [jobData, setJobData] = useState([]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [skip, setSkip] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const [activeTab, setActiveTab] = useState("draft");
    const [openByArrow, setOpenByArrow] = useState(false);
    const [ProjectOptions, setProjectOptions] = useState([]);
    const [invoiceType, setInvoiceType] = useState("");
    const [JobNumber, setJobNumber] = useState([]);
    // const [selectedJobnumner, setSelectedJobNumber] = useState([]);
    // const [selectedProject, setSelectedProject] = useState("");
    const [JobTypeOptions, SetJobTypeOptions] = useState([]);
    // const [selectedJobType, setselectedJobType] = useState("");
    const [ChargeOptions, SetChargeOptions] = useState([]);
    // const [selectedCharge, setselectedCharge] = useState("");
    const [selectedDate, setselectedDate] = useState("");
    const [error, setError] = useState(null);
    const [sortBy, setSortBy] = useState("dateCreated");
    const [selectedProject, setSelectedProject] = useState([]);
    const [selectedJobType, setSelectedJobType] = useState([]);
    const [selectedCharge, setSelectedCharge] = useState([]);
    const [selectedJobNumber, setSelectedJobNumber] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [searchParams] = useSearchParams();
    const jobType = searchParams.get('type') || 'revenue'; // default to revenue
    const [selectedDraftJobs, setSelectedDraftJobs] = useState([]);
    const [billGenerationData, setBillGenerationData] = useState([]);
    const [selectedBills, setSelectedBills] = useState([]);
    const [vendorInputValue, setVendorInputValue] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [expandedRow, setExpandedRow] = useState([]);
    const [existingJobShowPopup, setExistingJobShowPopup] = useState(false);
    const [existingJobSelected, setExistingJobSelected] = useState(null);
    const [lineItemsData, setLineItemsData] = useState({});
    const [selectedLineItems, setSelectedLineItems] = useState({})
    const [isVendorPopupOpen, setIsVendorPopupOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteJobId, setDeleteJobId] = useState(null);
    const [confirmSalesOpen, setConfirmSalesOpen] = useState(false);
    const [confirmCostOpen, setConfirmCostOpen] = useState(false);
    const [confirmRevertOpen, setConfirmRevertOpen] = useState(false);
    const [revertJobId, setRevertJobId] = useState(null);
    const [confirmBulkSubmitOpen, setConfirmBulkSubmitOpen] = useState(false);
    const [confirmBulkDeleteOpen, setConfirmBulkDeleteOpen] = useState(false);
    const [showChargeTypeModal, setShowChargeTypeModal] = useState(false);
    const [showDraftCostInvoiceModal, setShowDraftCostInvoiceModal] = useState(false);
    const [isInitialJobsLoading, setIsInitialJobsLoading] = useState(true);
    const [selectedDivision, setSelectedDivision] = useState("");
    const [isClearing, setIsClearing] = useState(false);
    const [selectedProfitCenter, setSelectedProfitCenter] = useState([]);
    const [selectedCity, setSelectedCity] = useState([]);
    const [selectedState, setSelectedState] = useState([]);
    const [selectedZone, setSelectedZone] = useState([]);
    const [plantCode, setPlantCode] = useState([]);
    const [showFilter, setShowFilter] = useState(true);
    const [statusCounts, setStatusCounts] = useState({
        draft: 0,
        submitted: 0,
        sales: 0,
        cost: 0
    });

    const fetchBillGenerationList = async (type, payload = {}) => {
        try {
            setIsInitialJobsLoading(true);
            const requestPayload = {
                type: type,
                limit: payload.limit || limit,
                skip: payload.skip || skip,
                filter: payload.filter || {},
                search: payload.search || searchTerm
            };

            const response = await axiosInstance.post("/job/bill_generation_list", requestPayload);

            if (response.data && Array.isArray(response.data.job)) {
                setBillGenerationData(response.data.job);
                const newTotal = response.data.totalCount || 0;
                setTotal(newTotal);
                setTotalPages(Math.ceil(newTotal / (payload.limit || limit)));
                if (type === "sales") {
                    setStatusCounts(prev => ({ ...prev, sales: newTotal }));
                } else if (type === "cost") {
                    setStatusCounts(prev => ({ ...prev, cost: newTotal }));
                }
            } else {
                setBillGenerationData([]);
                setTotal(0);
                setTotalPages(0);
            }
        } catch (error) {
            console.error("Error fetching bill generation data:", error);
            toast.error("Failed to fetch bill generation list");
        } finally {
            setIsInitialJobsLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === "sales" || activeTab === "cost") {
            const payload = buildPayload(skip);
            fetchBillGenerationList(activeTab, payload);
        }
    }, [activeTab, limit]);

    const handleDateSelection = (date) => {
        console.log("Selected Date:", date);
    };

    const isAllSelected = selectedRows.length === tableData.length;
    const isAnySelected = selectedRows.length > 0;

    const navigate = useNavigate();
    const handleAddNewClick = () => {
        navigate("/jobs_addnew");
    };

    const loadProjectOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/costsolution/projects/autosuggestion", {
                params: { term: inputValue || '' }
            }
            );

            const projects = res.data?.autosuggestion || [];

            if (openByArrow) {
                return projects.map(p => ({
                    label: p.label,
                    value: p.value
                }));
            }
            return projects.slice(0, 10).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error("Project suggestion error:", error);
            return [];
        }
    };

    const loadJobTypes = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/jobtype/autosuggestion", {
                params: { term: inputValue || '' },
            });

            const options = res.data?.autosuggestion || [];

            return options.map((item) => ({
                label: item.label,
                value: item.value,
            }));
        } catch (error) {
            console.error("Job type suggestion error:", error);
            return [];
        }
    };

    const loadChargeOptions = async (inputValue, callback) => {
        try {

            const res = await axiosInstance.get(
                "/charge/autocompletecharges",
                {
                    params: { term: inputValue }
                }
            );

            const options = res.data?.autosuggestion || [];

            const mapped = options.map((item) => ({
                label: item.label,
                value: item.value,
            }));

            callback(mapped);
        } catch (error) {
            console.error("Charge code suggestion error:", error);
            callback([]);
        }
    };

    const loadJobOptions = async (inputValue, callback) => {
        try {

            const res = await axiosInstance.get(
                "/jobs/getjobnumber",
                {
                    params: { term: inputValue || '' }
                }
            );

            const options = res.data?.autosuggestion || [];

            const mapped = options.map((item) => ({
                label: item.label,
                value: item.value,
            }));


            callback(mapped);
        } catch (error) {
            console.error("Job number suggestion error:", error);
            callback([]);
        }
    };

    const handleJobTypeChange = (selectedOption) => {
        setSelectedJobType(selectedOption);
    };

    const loadVendorOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/vendor/autosuggestion", {
                params: { term: inputValue || '' }
            });

            const data = res.data;

            if (data.success && Array.isArray(data.autosuggestion)) {
                return data.autosuggestion.map((item) => ({
                    label: item.label,
                    value: item.value,
                }));
            }

            return [];
        } catch (error) {
            console.error("Vendor suggestion error:", error);
            return [];
        }
    };

    useEffect(() => {
        const status = activeTab.toLowerCase();

        let filterstatus = [];

        if (status === 'submitted') {
            if (selectedStatus.trim() !== '') {
                filterstatus = [selectedStatus];
            } else {
                filterstatus = ['submitted', 'completed', 'partially invoiced'];
            }
        } else {
            filterstatus = [status];
        }

        const payload = {
            skip: 0,
            limit: limit,
            filter: {
                status: filterstatus,
            },
            search: searchTerm
        };

        setCurrentPage(0);
        setSkip(0);

        if (activeTab === "sales" || activeTab === "cost") {
            const billPayload = {
                skip: 0,
                limit: limit,
                filter: payload.filter
            };
            fetchBillGenerationList(activeTab, billPayload);
        } else {
            fetchjobs(payload);
        }

        // fetchjobs(payload);
    }, [activeTab, limit,]);



    const fetchjobs = async (payload) => {
        try {
            setIsInitialJobsLoading(true);
            const requestPayload = payload || {
                skip: skip,
                limit: limit,
                sortBy: sortBy,
                filter: {
                    status: Array.isArray(activeTab) ? activeTab : [activeTab.toLowerCase()]  // Always make status an array
                }
            };

            const response = await axiosInstance.post(
                `/job/list`,
                requestPayload
            );


            if (response.data && Array.isArray(response.data.job)) {
                setTableData(response.data.job);
                const newTotal = response.data.totalCount || 0;
                setTotal(newTotal);
                setTotalPages(Math.ceil(newTotal / limit));
                setJobData(response.data.job);
                if (activeTab === "draft") {
                    setStatusCounts(prev => ({ ...prev, draft: newTotal }));
                } else if (activeTab === "submitted") {
                    setStatusCounts(prev => ({ ...prev, submitted: newTotal }));
                }
            } else {
                setTableData([]);
                setJobData([]);
                setTotal(0);
                setTotalPages(0);
            }
            console.log("response..", response.data)
            console.log("contract..", response.data.job)
        } catch (error) {
            console.error("Error fetching contract data:", error);
            toast.error("Failed to fetch jobs");
        }
        finally {
            setIsInitialJobsLoading(false);
        }
    };


    // Filter jobs based on active tab
    const filteredJobs = jobData.filter(job => {
        const status = job.approval_status || "Draft";

        return (
            (activeTab === "draft") ||
            (activeTab === "submitted")
            // ||
            // (activeTab === "completed")
        );
    });
    console.log("filteredJobs", filteredJobs);
    console.log("jobData", jobData);

    const handleDelete = (id) => {
        setDeleteJobId(id);
        setConfirmOpen(true);
    };

    const confirmDelete = async () => {
        if (!deleteJobId) return;

        try {
            const response = await axiosInstance.delete(`/job/delete/${deleteJobId}`);

            if (response.status === 200) {
                toast.success("Job deleted successfully!");
                setTableData(prev => prev.filter(row => row.id !== deleteJobId));
                setTotal(prev => prev - 1);
                fetchjobs();
            } else {
                toast.error(`Failed to delete! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error deleting job:", error);
            toast.error("Something went wrong while deleting!");
        } finally {
            setConfirmOpen(false);
            setDeleteJobId(null);
        }
    };

    const cancelDelete = () => {
        setConfirmOpen(false);
        setDeleteJobId(null);
    };



    const handleRowSelect = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const handlePageClick = ({ selected }) => {
        const newSkip = selected * limit;
        setCurrentPage(selected);
        setSkip(newSkip);

        const payload = buildPayload(newSkip);

        if (activeTab === "sales" || activeTab === "cost") {
            const billPayload = {
                skip: newSkip,
                limit: limit,
                filter: payload.filter,
                search: searchTerm
            };
            fetchBillGenerationList(activeTab, billPayload);
        } else {
            fetchjobs(payload);
        }
        // fetchjobs(payload);
    };


    const handleDraftCheckboxChange = (jobId) => {

        setSelectedDraftJobs(prev =>
            prev.includes(jobId)
                ? prev.filter(id => id !== jobId)
                : [...prev, jobId]
        );
    };

    const handleSelectAllDrafts = () => {
        if (selectedDraftJobs.length === filteredJobs.length) {
            setSelectedDraftJobs([]);
        } else {
            setSelectedDraftJobs(filteredJobs.map(job => job.id));
        }
    };

    const handleBulkDelete = () => {
        if (selectedDraftJobs.length === 0) return;
        setConfirmBulkDeleteOpen(true);
    };

    const confirmBulkDelete = async () => {
        setConfirmBulkDeleteOpen(false);

        try {
            const response = await axiosInstance.delete('/job/bulk_delete', {
                data: { job_ids: selectedDraftJobs }
            });

            if (response.data.success) {
                toast.success(`${selectedDraftJobs.length} jobs deleted successfully!`);
                setSelectedDraftJobs([]);
                fetchjobs();
            } else {
                toast.error(response.data.message || "Failed to delete jobs");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to delete jobs");
            console.error("Bulk delete error:", error);
        }
    };

    const cancelBulkDelete = () => {
        setConfirmBulkDeleteOpen(false);
    };

    const handleBulkSubmit = () => {
        if (selectedDraftJobs.length === 0) return;
        setConfirmBulkSubmitOpen(true);
    };

    const confirmBulkSubmit = async () => {
        setConfirmBulkSubmitOpen(false);

        try {
            const response = await axiosInstance.post('/job/draft_bulkSubmit', {
                job_ids: selectedDraftJobs
            });

            if (response.data.success) {
                toast.success(`${selectedDraftJobs.length} jobs submitted successfully!`);
                setSelectedDraftJobs([]);
                fetchjobs();
            } else {
                toast.error(response.data.message || "Failed to submit jobs");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to submit jobs");
            console.error("Bulk submit error:", error);
        }
    };

    const cancelBulkSubmit = () => {
        setConfirmBulkSubmitOpen(false);
    };


    const handleDraftToSalesInvoice = () => {
        if (selectedDraftJobs.length === 0) {
            toast.warning("Please select at least one job to generate sales invoice");
            return;
        }
        const selectedJobsData = tableData.filter(job => selectedDraftJobs.includes(job.id));

        if (selectedJobsData.length > 0) {
            const firstProject = selectedJobsData[0]?.project_name;
            const allSameProject = selectedJobsData.every(job => job.project_name === firstProject);

            if (!allSameProject) {
                toast.error("Projects are mismatched. Please select jobs from the same project.");
                return;
            }
        }

        const firstDivision = selectedJobsData[0]?.job_type_division;
        const allSameDivision = selectedJobsData.every(job => job.job_type_division === firstDivision);

        if (!allSameDivision) {
            toast.error("Cannot mix SCS and FF divisions. Please choose a single division type.");
            return;
        }
        setConfirmSalesOpen(true);
    };


    const confirmDraftToSalesInvoice = async () => {
        setConfirmSalesOpen(false);

        try {
            const response = await axiosInstance.post('/job/jobdraft_to_invoice', {
                job_ids: selectedDraftJobs,
                invoice_type: 'sales'
            });

            if (response.data.success) {
                toast.success(`Sales bill generated successfully!`);

                navigate("/salesBillPage", {
                    state: {
                        billData: response.data,
                        selectedBills: selectedDraftJobs,
                        billType: 'sales'
                    }
                });
            } else {
                toast.error(response.data.message || "Failed to generate sales bill");
            }
        } catch (error) {
            console.error("Error generating sales bill:", error);
            toast.error(error.response?.data?.message || "Failed to generate sales bill");
        }
    };

    const cancelDraftToSalesInvoice = () => {
        setConfirmSalesOpen(false);
    };

    const handleDraftToCostInvoice = () => {
        if (selectedDraftJobs.length === 0) {
            toast.warning("Please select at least one job to generate cost invoice");
            return;
        }
        const selectedJobsData = tableData.filter(job => selectedDraftJobs.includes(job.id));
        if (selectedJobsData.length > 0) {
            const firstDivision = selectedJobsData[0]?.job_type_division;
            const allSameDivision = selectedJobsData.every(job => job.job_type_division === firstDivision);

            if (!allSameDivision) {
                toast.error("Cannot mix SCS and FF divisions. Please choose a single division type.");
                return;
            }
        }
        setShowDraftCostInvoiceModal(true);
        setInvoiceType("");
        // setConfirmCostOpen(true);
    };


    const confirmDraftToCostInvoice = async (costInvoiceType = null) => {
        setConfirmCostOpen(false);

        try {
            const response = await axiosInstance.post('/job/jobdraft_to_invoice', {
                job_ids: selectedDraftJobs,
                invoice_type: 'cost',
                cost_invoice_type: costInvoiceType
            });

            if (response.data.success) {
                toast.success(`Cost bill generated successfully!`);

                navigate("/costBillPage", {
                    state: {
                        billData: response.data,
                        selectedBills: selectedDraftJobs,
                        billType: 'cost'
                    }
                });
            } else {
                toast.error(response.data.message || "Failed to generate cost bill");
            }
        } catch (error) {
            console.error("Error generating cost bill:", error);
            toast.error(error.response?.data?.message || "Failed to generate cost bill");
        }
    };

    const cancelDraftToCostInvoice = () => {
        setConfirmCostOpen(false);
    };


    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(0);
        setSkip(0);

        const payload = buildPayload(0, newLimit); // <-- uses filters + new limit
        fetchjobs(payload);
    };




    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortBy(value);
        setSkip(0);
        setCurrentPage(0);
    };

    const [selectedJobs, setSelectedJobs] = useState([]);

    const handleCheckboxChange = (jobId) => {
        const job = filteredJobs.find(j => j.id === jobId);
        if (job?.approval_status === "completed") return;

        setSelectedJobs(prev =>
            prev.includes(jobId)
                ? prev.filter(id => id !== jobId)
                : [...prev, jobId]
        );
    };

    const handleSelectAll = () => {
        const selectableJobs = filteredJobs.filter(job => job.approval_status !== "completed");

        if (selectedJobs.length === selectableJobs.length) {
            setSelectedJobs([]);
        } else {
            setSelectedJobs(selectableJobs.map(job => job.id));
        }
    };

    const handleApply = () => {
        const payload = buildPayload();
        if (activeTab.toLowerCase() === 'submitted') {
            const hasOtherFilters = Object.keys(payload.filter).some(key =>
                key !== 'status' && payload.filter[key] &&
                (Array.isArray(payload.filter[key]) ? payload.filter[key].length > 0 : true)
            );
            const hasCustomStatus = selectedStatus && selectedStatus.trim() !== '';
            if (!hasOtherFilters && !hasCustomStatus) {
                toast.warning("Please select at least one filter before applying.");
                return;
            }
        } else {
            const { status, ...restFilter } = payload.filter || {};
            const isFilterEmpty = Object.keys(restFilter).length === 0;
            if (isFilterEmpty) {
                toast.warning("Please select at least one filter before applying.");
                return;
            }
        }
        setSkip(0);
        setCurrentPage(0);

        if (activeTab === "sales" || activeTab === "cost") {
            const billPayload = {
                skip: 0,
                limit: limit,
                filter: payload.filter,
                search: searchTerm
            };
            fetchBillGenerationList(activeTab, billPayload);
        } else {
            fetchjobs(payload);
        }
        console.log("payload....", payload);
    };

    useEffect(() => {
        setExpandedRow([]);
        setSelectedProject([]);
        setSelectedJobType([]);
        setSelectedCharge([]);
        setSelectedJobNumber([]);
        setselectedDate("");
        setFromDate(null);
        setToDate(null);
        setSelectedStatus("");
        setSelectedDivision("");
        setSelectedVendor([]);
        setSelectedProfitCenter([]);
        setSelectedCity([]);
        setSelectedState([]);
        setSelectedZone([]);
        setPlantCode([]);
        setSkip(0);
        setCurrentPage(0);
        setSelectedDraftJobs([]);
        setSelectedJobs([]);
        setSelectedBills([]);
        setSelectedLineItems({});
    }, [activeTab]);

    const handleClearFilters = () => {

        const isAlreadyEmpty =
            (!selectedProject || selectedProject.length === 0) &&
            (!selectedJobType || selectedJobType.length === 0) &&
            (!selectedCharge || selectedCharge.length === 0) &&
            (!selectedJobNumber || selectedJobNumber.length === 0) &&
            !selectedDate &&
            !fromDate &&
            !toDate &&
            (!selectedVendor || selectedVendor.length === 0) &&
            !selectedDivision &&
            !searchTerm &&
            !selectedStatus &&
            (!selectedProfitCenter || selectedProfitCenter.length === 0) &&
            (!selectedCity || selectedCity.length === 0) &&
            (!selectedState || selectedState.length === 0) &&
            (!selectedZone || selectedZone.length === 0) &&
            (!plantCode || plantCode.length === 0);

        if (isAlreadyEmpty) {
            toast.warning("No filters to reset.");
            return;
        }

        setSelectedProject([]);
        setSelectedJobType([]);
        setSelectedCharge([]);
        setSelectedJobNumber([]);
        setselectedDate("");
        setFromDate(null);
        setToDate(null);
        setSelectedVendor([]);
        setSelectedDivision("");
        setSearchTerm("");
        setSelectedStatus("");
        setSelectedProfitCenter([]);
        setSelectedCity([]);
        setSelectedState([]);
        setSelectedZone([]);
        setPlantCode([]);
        setSkip(0);
        setCurrentPage(0);

        if (activeTab === "sales" || activeTab === "cost") {
            fetchBillGenerationList(activeTab, { skip: 0, limit: limit, search: "" });
        } else {
            if (activeTab.toLowerCase() === 'submitted') {
                const payload = {
                    skip: 0,
                    limit: limit,
                    filter: {
                        status: ['submitted', 'completed', 'partially invoiced']
                    },
                    search: ""
                };
                fetchjobs(payload);
            } else {
                fetchjobs();
            }
        }
    };

    const buildPayload = (customSkip = 0, customLimit = limit) => {
        const filter = {};
        const status = activeTab.toLowerCase();
        console.log("statussssssssssss", status);

        if (status === 'submitted') {
            filter.status = selectedStatus ? [selectedStatus] : ['submitted', 'completed', 'partially invoiced'];
        } else if (status === 'draft') {
            filter.status = [status];
        }

        if (selectedProject && selectedProject.length > 0) filter.project = selectedProject.map(v => v.value);
        if (selectedJobType && selectedJobType.length > 0) filter.jobtype = selectedJobType.map(v => v.value);
        if (selectedCharge && selectedCharge.length > 0) filter.charge = selectedCharge.map(v => v.value);
        if (selectedJobNumber && selectedJobNumber.length > 0) filter.jobnumber = selectedJobNumber.map(v => v.value);
        if (selectedDate) filter.jobcreatedate = selectedDate;
        if (selectedDivision) { filter.job_type_division = selectedDivision; }
        if (selectedProfitCenter && selectedProfitCenter.length > 0) filter.profit_centre = selectedProfitCenter.map(v => v.value);
        if (selectedCity && selectedCity.length > 0) filter.city = selectedCity.map(v => v.value);
        if (selectedState && selectedState.length > 0) filter.state = selectedState.map(v => v.value);
        if (selectedZone && selectedZone.length > 0) filter.zones = selectedZone.map(v => v.value);
        if (plantCode && plantCode.length > 0) filter.plant_code = plantCode.map(v => v.value);


        const formatDate = (date) => {
            if (!date) return null;
            return date.toISOString().split("T")[0];
        };

        if (activeTab === "sales" || activeTab === "cost") {
            if (fromDate) filter.from_date = formatDate(fromDate);
            if (toDate) filter.to_date = formatDate(toDate);
        }
        if (selectedVendor?.length > 0) {
            filter.vendor_id = selectedVendor.map(v => v.value);
        }

        console.log("Build Payload Filter:", filter);

        return {
            skip: customSkip,
            limit: customLimit,
            filter,
            search: searchTerm
        };
    };

    const handleRowClick = async (job) => {
        if (!permission || permission.view_permission !== "1") {
            return;
        }

        try {

            const response = await axiosInstance.get(
                `/job/edit/${job.id}`
            );

            // Navigate to view page with the job data
            navigate("/jobs_module", { state: { job: response.data.data } });
        } catch (error) {
            console.error("Error fetching job details:", error);
            toast.error("Failed to load job details");
            // Optional: Navigate with basic data if API fails
            navigate("/jobs_module", { state: { job } });
        }
    };

    const handleSalesRowClick = async (job) => {
        try {

            const response = await axiosInstance.get(
                `/job/edit/${job.id}`
            );

            // Navigate to view page with the job data
            navigate("/SalesViewPage", { state: { job: response.data.data } });
        } catch (error) {
            console.error("Error fetching job details:", error);
            toast.error("Failed to load job details");
            // Optional: Navigate with basic data if API fails
            navigate("/SalesViewPage", { state: { job } });
        }
    };

    const handleCostRowClick = async (job) => {
        try {
            // Fetch the full job details
            // const response = await axios.get(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/job/edit/${job.id}`
            // );

            const response = await axiosInstance.get(
                `/job/edit/${job.id}`
            );

            // Navigate to view page with the job data
            navigate("/CostViewPage", { state: { job: response.data.data } });
        } catch (error) {
            console.error("Error fetching job details:", error);
            toast.error("Failed to load job details");
            // Optional: Navigate with basic data if API fails
            navigate("/CostViewPage", { state: { job } });
        }
    };

    const handleJobSelection = (jobNo) => {
        setSelectedJobs(prev =>
            prev.includes(jobNo)
                ? prev.filter(id => id !== jobNo)
                : [...prev, jobNo]
        );
    };

    const handleEditClick = async (job_id) => {
        try {
            // const response = await axios.get(
            //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/job/edit/${job_id}`
            // );

            const response = await axiosInstance.get(
                `/job/edit/${job_id}`
            );


            console.log("Full API response:", response);
            console.log("API response data:", response.data);

            if (response.data) {
                // Navigate to the edit page, passing the job data as state
                navigate(`/jobs_addnew`, { state: { job_data: response.data } });
            } else {
                throw new Error("Job data not found");
            }
        } catch (error) {
            setError(error.message);
            console.error("Error fetching job details:", error);
        }
    };

    const handleRevertClick = (jobId) => {
        setRevertJobId(jobId);
        setConfirmRevertOpen(true);
    };

    const confirmRevert = async () => {
        setConfirmRevertOpen(false);

        try {
            const response = await axiosInstance.post('/job/submittedjobs_revert', { id: revertJobId });

            if (response.data.status === 'success') {
                toast.success(response.data.message || 'Job reverted successfully!');

                // Refresh job list with current filters/pagination
                const requestPayload = {
                    skip,
                    limit,
                    sortBy,
                    filter: {
                        status: ["submitted", "completed", "partially invoiced"]
                    }
                };
                fetchjobs(requestPayload);
            } else {
                toast.error(response.data.message || 'Unexpected error occurred.');
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Failed to revert the job. Please try again.';
            toast.error(errorMsg);
        } finally {
            setRevertJobId(null);
        }
    };

    const cancelRevert = () => {
        setConfirmRevertOpen(false);
        setRevertJobId(null);
    };


    const handleBillSelection = (jobId) => {

        const jobToSelect = billGenerationData.find(job => job.id === jobId);
        if (!selectedBills.includes(jobId)) {
            if (selectedBills.length > 0) {
                const firstSelectedJob = billGenerationData.find(job => selectedBills.includes(job.id));
                const firstDivision = firstSelectedJob?.job_type_division;

                if (jobToSelect?.job_type_division !== firstDivision) {
                    toast.error(`Cannot mix ${firstDivision} and ${jobToSelect?.job_type_division} divisions. Please select jobs from the same division type.`);
                    return;
                }
            }
        }

        const isSelected = selectedBills.includes(jobId);

        if (isSelected) {
            setSelectedBills(prev => prev.filter(id => id !== jobId));
            setSelectedLineItems(prev => {
                const newItems = { ...prev };
                delete newItems[jobId];
                return newItems;
            });
        } else {
            setSelectedBills(prev => [...prev, jobId]);

            const lineItemIds = lineItemsData[jobId]
                ?.filter(item => !item.is_pushed)
                ?.map(item => item.job_line_id)
                ?.filter(Boolean) || [];

            setSelectedLineItems(prev => ({
                ...prev,
                [jobId]: lineItemIds
            }));
        }
    };

    const handleSelectAllBills = (e) => {
        const isChecked = e.target.checked;

        if (isChecked) {

            const divisions = [...new Set(billGenerationData.map(job => job.job_type_division))];

            if (divisions.length > 1) {
                toast.error("Cannot select all jobs as they contain mixed divisions (SCS/FF). Please select jobs from the same division type.");
                return;
            }

            const allJobIds = billGenerationData.map(job => job.id);
            setSelectedBills(allJobIds);

            // Select only unpushed line items
            const selectedLineItems = {};
            billGenerationData.forEach(job => {
                const jobLineItems = lineItemsData[job.id]
                    ?.filter(item => !item.is_pushed)
                    ?.map(item => item.job_line_id)
                    ?.filter(Boolean) || [];

                selectedLineItems[job.id] = jobLineItems;
            });

            setSelectedLineItems(selectedLineItems);
        } else {
            setSelectedBills([]);
            setSelectedLineItems({});
        }
    };

    const handleGenerateBill = async (costInvoiceType = null) => {
        const hasJobs = selectedBills.length > 0;
        const hasLines = Object.values(selectedLineItems).some(items => items.length > 0);

        if (!hasJobs && !hasLines) {
            toast.warning("Please select at least one job or line item.");
            return;
        }

        if (selectedBills.length > 0) {
            const selectedJobs = billGenerationData.filter(job => selectedBills.includes(job.id));

            if (selectedJobs.length > 0) {
                if (activeTab === "sales") {
                    const firstProject = selectedJobs[0]?.project_name;
                    const allSameProject = selectedJobs.every(job => job.project_name === firstProject);

                    if (!allSameProject) {
                        toast.error("Projects are mismatched. Please select jobs from the same project.");
                        return;
                    }
                }

                const firstDivision = selectedJobs[0]?.job_type_division;
                const allSameDivision = selectedJobs.every(job => job.job_type_division === firstDivision);

                if (!allSameDivision) {
                    toast.error("Cannot mix SCS and FF divisions. Please choose a single division type.");
                    return;
                }
            }
        }

        const jobsPayload = selectedBills.map(jobId => {
            const selectedLines = selectedLineItems[jobId];

            const job = billGenerationData.find(job => job.id === jobId);

            const lineIds = (selectedLines && selectedLines.length > 0)
                ? selectedLines
                : job?.job_line_ids
                    ? JSON.parse(job.job_line_ids)
                    : [];

            return {
                job_id: jobId,
                job_line_ids: lineIds
            };
        });

        const payload =
            activeTab === "cost"
                ? { jobs: jobsPayload, cost_invoice_type: costInvoiceType }
                : { jobs: jobsPayload };
        try {
            const response = await axiosInstance.post(
                activeTab === "sales"
                    ? "/job/generate_multi_sales_line_invoice"
                    : "/job/generate_multi_cost_line_invoice",
                payload
            );

            if (response.data.success) {
                toast.success(`${activeTab === "sales" ? "Sales" : "Cost"} invoice generated successfully`);
                navigate(activeTab === "sales" ? "/salesBillPage" : "/costBillPage", {
                    state: {
                        billData: response.data,
                        selectedBills: jobsPayload,
                        billType: activeTab
                    }
                });
            } else {
                toast.error(response.data.message || "Failed to generate invoice.");
            }
        } catch (error) {
            console.log("Invoice generation error:", error?.response?.data);
            const backendMsg =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "Failed to generate invoice.";

            toast.error(backendMsg);
        }
    };

    const fetchLineItems = async (jobId) => {
        try {
            const response = await axiosInstance.post(`/job/job_line_datas/${jobId}`);
            setLineItemsData(prev => ({
                ...prev,
                [jobId]: response.data.job_lines
            }));

            if (activeTab === "sales") {
                const unpushedItems = response.data.job_lines
                    .filter(item => !item.is_pushed && item.job_cost_line_id)
                    .map(item => item.job_cost_line_id);

                setSelectedLineItems(prev => ({
                    ...prev,
                    [jobId]: unpushedItems
                }));
            } else if (activeTab === "cost") {
                const allItems = response.data.job_lines
                    .filter(item => item.job_cost_line_id)
                    .map(item => item.job_cost_line_id);

                setSelectedLineItems(prev => ({
                    ...prev,
                    [jobId]: allItems
                }));
            }
        } catch (error) {
            console.error("Error fetching line items:", error);
            toast.error("Failed to load line items");
        }
    };

    const fetchSalesLineItems = async (jobId) => {
        try {
            const response = await axiosInstance.post(`job/sales_job_line_datas/${jobId}`);
            setLineItemsData(prev => ({
                ...prev,
                [jobId]: response.data.job_lines
            }));

            const unpushedItems = response.data.job_lines
                .filter(item => !item.is_pushed && item.job_sales_line_id)
                .map(item => item.job_sales_line_id);

            setSelectedLineItems(prev => ({
                ...prev,
                [jobId]: unpushedItems
            }));
        } catch (error) {
            console.error("Error fetching line items:", error);
            toast.error("Failed to load line items");
        }
    };

    const Tooltip = ({ message, children }) => {
        const [showTooltip, setShowTooltip] = useState(false);

        const shouldShow = showTooltip && message;

        return (
            <div style={{ position: 'relative' }}>
                <div
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    {children}
                </div>
                {shouldShow && (
                    <div style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        whiteSpace: 'nowrap',
                        zIndex: 100,
                        marginBottom: '5px'
                    }}>
                        {message}
                    </div>
                )}
            </div>
        );
    };

    const handleSearch = async (searchValue) => {
        setSearchTerm(searchValue);

        const status = activeTab.toLowerCase();

        let filterstatus = [];

        if (status === 'submitted') {
            if (selectedStatus.trim() !== '') {
                filterstatus = [selectedStatus];
            } else {
                filterstatus = ['submitted', 'completed', 'partially invoiced'];
            }
        } else {
            filterstatus = [status];
        }

        const payload = {
            skip: 0,
            limit: limit,
            filter: {
                status: filterstatus,
            },
            search: searchValue
        };

        setCurrentPage(0);
        setSkip(0);

        if (activeTab === "sales" || activeTab === "cost") {
            const billPayload = {
                skip: 0,
                limit: limit,
                filter: payload.filter,
                search: searchValue
            };
            fetchBillGenerationList(activeTab, billPayload);
        } else {
            fetchjobs(payload);
        }
    };

    useEffect(() => {
        if (searchTerm === "" && (activeTab === "sales" || activeTab === "cost")) {
            const payload = buildPayload();
            fetchBillGenerationList(activeTab, {
                skip: 0,
                limit: limit,
                filter: payload.filter,
                search: ""
            });
        }
    }, [searchTerm, activeTab]);

    const formatStatus = (status) => {
        if (!status) return "";
        return status
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    useEffect(() => {
        if (!isClearing) return;

        const payload = buildPayload(0);

        setSkip(0);
        setCurrentPage(0);

        if (activeTab === "sales" || activeTab === "cost") {
            fetchBillGenerationList(activeTab, {
                skip: 0,
                limit: limit,
                filter: payload.filter,
                search: searchTerm
            });
        } else {
            fetchjobs(payload);
        }

        setIsClearing(false);

    }, [isClearing]);


    return (
        <>
            <Jobs_header onSearch={handleSearch} />
            {jobType !== 'report' && (
                <div className='jobs'>
                    <div className="jobs-header">
                        <div className="jobs-left-header">
                            <button
                                className={`jobs-btn jobs-draft-btn ${activeTab === "draft" ? "active" : ""}`}
                                onClick={() => setActiveTab("draft")}
                            >
                                Draft{activeTab === "draft" && ``}
                            </button>
                            <button
                                className={`jobs-btn jobs-submitted-btn ${activeTab === "submitted" ? "active" : ""}`}
                                onClick={() => setActiveTab("submitted")}
                            >
                                Submitted{activeTab === "submitted" && ``}
                            </button>

                            <AdditionalPermissionWrapper permissionKey="sales_job_list" moduleId={ModuleId}>
                                <button
                                    className={`jobs-btn jobs-sales-bill-btn ${activeTab === "sales" ? "active" : ""}`}
                                    onClick={() => setActiveTab("sales")}
                                >
                                    Generate Sales Bill{activeTab === "sales" && ``}
                                </button>

                            </AdditionalPermissionWrapper>

                            <AdditionalPermissionWrapper permissionKey="cost_job_list" moduleId={ModuleId}>
                                <button
                                    className={`jobs-btn jobs-cost-bill-btn ${activeTab === "cost" ? "active" : ""}`}
                                    onClick={() => setActiveTab("cost")}
                                >
                                    Generate Cost Bill{activeTab === "cost" && ``}
                                </button>
                            </AdditionalPermissionWrapper>



                            {/* <button
                            className={`jobs-btn jobs-completed-btn ${activeTab === "completed" ? "active" : ""}`}
                            onClick={() => setActiveTab("completed")}
                        >
                            Completed{activeTab === "completed" && ``}
                        </button> */}
                        </div>

                        <div className="right-header">
                            {/* {!isAnySelected ? (
                        <>
                            <DatePicker onDateChange={handleDateSelection} />

                            <h4>Sort by :</h4>
                            <div className="dropdown">
                                <select id="options" className="dropdown-select">
                                    <option value="option1">Date Created</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </div>
                        </>
                    ) : (
                        <button id="deleteBtn" className="deleteBtn" onClick={handleDeleteRow}>
                            Delete
                        </button>
                    )} */}

                            {/* Existing job */}
                            <AdditionalPermissionWrapper permissionKey="additional_charges_to_invoice" moduleId={ModuleId}>
                                <button
                                    style={{
                                        backgroundColor: "#2563EB",
                                        color: "white",
                                        padding: "10px 20px",
                                        borderRadius: "6px",
                                        fontWeight: "500",
                                        border: "none",
                                        cursor: "pointer",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        transition: "background-color 0.3s ease",
                                        height: '35px'
                                    }}
                                    onMouseOver={(e) => (e.target.style.backgroundColor = "#1D4ED8")}
                                    onMouseOut={(e) => (e.target.style.backgroundColor = "#2563EB")}
                                    onClick={() => setExistingJobShowPopup(true)}
                                >
                                    Add Additional Charges
                                </button>
                            </AdditionalPermissionWrapper>

                            <AddExistingJob
                                isOpen={existingJobShowPopup}
                                onClose={() => setExistingJobShowPopup(false)}
                                existingJobSelected={existingJobSelected}
                                setExistingJobSelected={setExistingJobSelected}
                            />

                            <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
                                {!isAnySelected && jobType === 'revenue' && (
                                    <button id="addNewBtn" onClick={handleAddNewClick}>
                                        Add New
                                    </button>
                                )}
                            </PermissionWrapper>

                            <div
                                className={`project-popup-filter-setshow-image ${showFilter ? "active" : ""}`}
                                onClick={() => setShowFilter(!showFilter)}
                            >
                                <img
                                    src={filterOpenCloseIcon}
                                    alt="Filter"
                                    className="project-popup-filter-icon"
                                    title={showFilter ? "Hide Filters" : "Show Filters"}
                                />
                            </div>

                        </div>
                    </div>

                    <div className={`filteropenclose-wrapper ${showFilter ? "open" : ""}`}>
                        <div className="filter-scope"
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "15px",
                                padding: "15px",
                                border: "1px solid #E5E5E5",
                                borderRadius: "12px",
                                margin: "5px 10px 15px 10px",
                            }}
                        >
                            <JobsFilter
                                showFilters={showFilters}
                                setShowFilters={setShowFilters}
                                activeTab={activeTab}
                                selectedProject={selectedProject}
                                setSelectedProject={setSelectedProject}
                                selectedJobNumber={selectedJobNumber}
                                setSelectedJobNumber={setSelectedJobNumber}
                                selectedJobType={selectedJobType}
                                setSelectedJobType={setSelectedJobType}
                                selectedDate={selectedDate}
                                setselectedDate={setselectedDate}
                                selectedStatus={selectedStatus}
                                setSelectedStatus={setSelectedStatus}
                                fromDate={fromDate}
                                toDate={toDate}
                                setFromDate={setFromDate}
                                setToDate={setToDate}
                                selectedVendor={selectedVendor}
                                selectedDivision={selectedDivision}
                                setSelectedDivision={setSelectedDivision}
                                setSelectedVendor={setSelectedVendor}
                                vendorInputValue={vendorInputValue}
                                setVendorInputValue={setVendorInputValue}
                                setMenuOpen={setMenuOpen}
                                loadProjectOptions={loadProjectOptions}
                                setOpenByArrow={setOpenByArrow}
                                loadJobOptions={loadJobOptions}
                                loadJobTypes={loadJobTypes}
                                loadVendorOptions={loadVendorOptions}
                                handleClearFilters={handleClearFilters}
                                handleApply={handleApply}
                                setIsClearing={setIsClearing}
                                selectedProfitCenter={selectedProfitCenter}
                                setSelectedProfitCenter={setSelectedProfitCenter}
                                selectedCity={selectedCity}
                                setSelectedCity={setSelectedCity}
                                selectedState={selectedState}
                                setSelectedState={setSelectedState}
                                selectedZone={selectedZone}
                                setSelectedZone={setSelectedZone}
                                plantCode={plantCode}
                                setPlantCode={setPlantCode}
                            />
                        </div>
                    </div>

                    <div className="table-top-actions">
                        {/* {activeTab === "submitted" && (
                            <div className="selection-info">
                                {selectedJobs.length === 0 ? (
                                    <span>Select & generate an invoice</span>
                                ) : (
                                    <span className='jobs-selected'>{selectedJobs.length} jobs selected</span>
                                )}
                            </div>
                        )} */}
                        {/* 
                        <AdditionalPermissionWrapper permissionKey="rev_gen_invoice" moduleId={ModuleId}>
                            {selectedJobs.length > 0 && activeTab === "submitted" && (
                                selectedJobs.some(jobId => {
                                    const job = filteredJobs.find(j => j.id === jobId);
                                    return job?.approval_status === "submitted";
                                }) && (
                                    <button className="generate-invoice-btn" onClick={handleGenerateClick}>
                                        Generate Invoice
                                    </button>
                                )
                            )} */}

                        {/* draft */}
                        {activeTab === "draft" && selectedDraftJobs.length > 0 && (
                            <>
                                <div className="selection-info">
                                    <span className='jobs-selected'>{selectedDraftJobs.length} jobs selected</span>
                                </div>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <button className="checked-generate-sales-invoice-btn" onClick={handleDraftToSalesInvoice}>
                                        Generate Sales Invoice
                                        {/* ({selectedDraftJobs.length})  */}
                                    </button>
                                    <button className="checked-generate-cost-invoice-btn" onClick={handleDraftToCostInvoice}>
                                        Generate Cost Invoice
                                        {/* ({selectedDraftJobs.length})  */}
                                    </button>
                                    <button className="checked-submit-invoice-btn" onClick={handleBulkSubmit}>
                                        Bulk Submit
                                        {/* ({selectedDraftJobs.length})  */}
                                    </button>
                                    <button className="checked-delete-invoice-btn" onClick={handleBulkDelete}>
                                        Bulk Delete
                                        {/* ({selectedDraftJobs.length})  */}
                                    </button>
                                </div>
                            </>
                        )}
                        {/* </AdditionalPermissionWrapper> */}

                    </div>

                    {activeTab === "sales" || activeTab === "cost" ? (
                        <>
                            <div className="table-top-actions">
                                <div className="selection-info">
                                    <div className="sc-summary-row">
                                        <div className="sc-summary-pill">
                                            <span className="sc-summary-label">
                                                Total Records:
                                                <span className="sc-summary-count">
                                                    {activeTab === "sales"
                                                        ? statusCounts.sales
                                                        : statusCounts.cost}
                                                </span>
                                            </span>

                                            <span className="sc-summary-separator">-</span>

                                            {selectedBills.length === 0 ? (
                                                <span className="sc-summary-hint">
                                                    Select jobs to generate {activeTab} bill
                                                </span>
                                            ) : (
                                                <span className="sc-summary-selected">
                                                    {selectedBills.length} jobs selected
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {selectedBills.length > 0 && activeTab === "cost" && (
                                            <button
                                                className="checked-submit-invoice-btn"
                                                onClick={async () => {
                                                    const jobsPayload = selectedBills.map(jobId => {
                                                        const selectedLines = selectedLineItems[jobId];

                                                        const job = billGenerationData.find(job => job.id === jobId);

                                                        const lineIds = (selectedLines && selectedLines.length > 0)
                                                            ? selectedLines
                                                            : job?.job_line_ids
                                                                ? JSON.parse(job.job_line_ids)
                                                                : [];

                                                        return {
                                                            job_id: parseInt(jobId),
                                                            job_cost_line_ids: lineIds
                                                        };
                                                    });

                                                    const payload = { jobs: jobsPayload };
                                                    console.log("Payload to send:", payload);

                                                    try {
                                                        const response = await axiosInstance.get('/job/bulk_jobline_vendor', { params: payload });
                                                        setIsVendorPopupOpen(true);
                                                        setVendorData(response.data.data);
                                                    } catch (err) {
                                                        console.error("Error sending job data", err);
                                                        toast.error("Failed to fetch job line items");
                                                    }
                                                }}

                                            >
                                                Add Vendor
                                            </button>
                                        )}

                                        {isVendorPopupOpen && (
                                            <AddVendor
                                                onClose={(result) => {
                                                    setIsVendorPopupOpen(false);
                                                    if (result?.updated) {
                                                        selectedBills.forEach(jobId => {
                                                            fetchLineItems(jobId);
                                                        });
                                                    }
                                                }}
                                                jobData={vendorData}
                                            />
                                        )}
                                    </div>

                                    <AdditionalPermissionWrapper
                                        permissionKey={
                                            activeTab === "sales"
                                                ? "generate_sales_invoice"
                                                : "generate_cost_invoice"
                                        }
                                        moduleId={ModuleId}
                                    >
                                        {selectedBills.length > 0 && (
                                            <button
                                                className="generate-invoice-btn"
                                                onClick={() => {
                                                    if (activeTab === "cost") {
                                                        setShowChargeTypeModal(true);
                                                    } else {
                                                        handleGenerateBill();
                                                    }
                                                }}
                                            >
                                                Generate {activeTab === "sales" ? "Sales" : "Cost"} Bill
                                            </button>
                                        )}
                                    </AdditionalPermissionWrapper>
                                </div>

                            </div>

                            <div className='jobs-table' style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{
                                                width: "60px",
                                                minWidth: "60px",
                                                textAlign: "center",
                                                padding: "4px",
                                                cursor: 'pointer'
                                            }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedBills.length === billGenerationData.length && billGenerationData.length > 0}
                                                    onChange={handleSelectAllBills}
                                                />
                                            </th>
                                            {activeTab === "cost" && (
                                                <th onClick={() => {
                                                    if (expandedRow.length === billGenerationData.length) {
                                                        setExpandedRow([]);
                                                    } else {
                                                        const allJobIds = billGenerationData.map(job => job.id);
                                                        setExpandedRow(allJobIds);
                                                        allJobIds.forEach(id => {
                                                            if (!expandedRow.includes(id)) {
                                                                fetchLineItems(id);
                                                            }
                                                        });
                                                    }
                                                }} style={{
                                                    width: "60px",
                                                    minWidth: "60px",
                                                    textAlign: "center",
                                                    padding: "4px",
                                                    cursor: 'pointer'
                                                }}>
                                                    <Eye
                                                        size={18}
                                                        color={
                                                            expandedRow.length === billGenerationData.length && billGenerationData.length > 0
                                                                ? "#3b82f6"
                                                                : "#9ca3af"
                                                        }
                                                    />
                                                </th>
                                            )}
                                            {activeTab === "sales" && (
                                                <th onClick={() => {
                                                    if (expandedRow.length === billGenerationData.length) {
                                                        setExpandedRow([]);
                                                    } else {
                                                        const allJobIds = billGenerationData.map(job => job.id);
                                                        setExpandedRow(allJobIds);
                                                        allJobIds.forEach(id => {
                                                            if (!expandedRow.includes(id)) {
                                                                fetchSalesLineItems(id);
                                                            }
                                                        });
                                                    }
                                                }} style={{
                                                    width: "60px",
                                                    minWidth: "60px",
                                                    textAlign: "center",
                                                    padding: "4px",
                                                    cursor: 'pointer'
                                                }}>
                                                    <Eye
                                                        size={18}
                                                        color={
                                                            expandedRow.length === billGenerationData.length && billGenerationData.length > 0
                                                                ? "#3b82f6"
                                                                : "#9ca3af"
                                                        }
                                                    />
                                                </th>
                                            )}
                                            <th>Job No</th>
                                            {activeTab === "sales" && (
                                                <th>Supply Period</th>
                                            )}
                                            <th>Job Type</th>
                                            <th>Job Type Division</th>
                                            <th>Project</th>
                                            {activeTab === "cost" && <th>Vendor</th>}
                                            <th>{activeTab === "sales" ? "Sales Amount" : "Cost Amount"}</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {billGenerationData.length > 0 ? (
                                            billGenerationData.map((job, index) => {
                                                const isExpanded = expandedRow.includes(job.id);
                                                const allSalesItemsPushed = activeTab === 'sales' &&
                                                    lineItemsData[job.id]?.length > 0 &&
                                                    lineItemsData[job.id]?.every(item => item.is_pushed === true);
                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr className="table-row" style={{ cursor: 'pointer' }}>
                                                            <td style={{
                                                                width: "60px",
                                                                minWidth: "60px",
                                                                textAlign: "center",
                                                                padding: "4px",
                                                                cursor: 'pointer'
                                                            }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedBills.includes(job.id)}
                                                                    onChange={() => handleBillSelection(job.id)}
                                                                />
                                                            </td>
                                                            {activeTab === "cost" && (
                                                                <td
                                                                    onClick={() => {
                                                                        if (expandedRow.includes(job.id)) {
                                                                            setExpandedRow(expandedRow.filter(id => id !== job.id));
                                                                        } else {
                                                                            setExpandedRow([...expandedRow, job.id]);
                                                                            if (!selectedBills.includes(job.id)) {
                                                                                setSelectedBills(prev => [...prev, job.id]);
                                                                            }
                                                                            fetchLineItems(job.id);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: "60px",
                                                                        minWidth: "60px",
                                                                        textAlign: "center",
                                                                        padding: "4px",
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    <Eye color={isExpanded ? "#3b82f6" : "#9ca3af"} size={18} />
                                                                </td>
                                                            )}

                                                            {activeTab === "sales" && (
                                                                <td
                                                                    onClick={() => {
                                                                        if (expandedRow.includes(job.id)) {
                                                                            setExpandedRow(expandedRow.filter(id => id !== job.id));
                                                                        } else {
                                                                            setExpandedRow([...expandedRow, job.id]);
                                                                            if (!selectedBills.includes(job.id)) {
                                                                                setSelectedBills(prev => [...prev, job.id]);
                                                                            }
                                                                            fetchSalesLineItems(job.id);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: "60px",
                                                                        minWidth: "60px",
                                                                        textAlign: "center",
                                                                        padding: "4px",
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    <Eye color={isExpanded ? "#3b82f6" : "#9ca3af"} size={18} />
                                                                </td>
                                                            )}

                                                            <td onClick={() => (activeTab === "sales" ? handleSalesRowClick(job) : handleCostRowClick(job))}>
                                                                {job.job_number}
                                                            </td>
                                                            {activeTab === "sales" && (
                                                                <td onClick={() => (activeTab === "sales" ? handleSalesRowClick(job) : handleCostRowClick(job))}>
                                                                    {job.supply_period && (
                                                                        <span className="supply-period-pill">
                                                                            <svg viewBox="0 0 24 24" fill="currentColor">
                                                                                <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1zm12 8H5v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8z" />
                                                                            </svg>
                                                                            {job.supply_period}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            )}
                                                            <td onClick={() => (activeTab === "sales" ? handleSalesRowClick(job) : handleCostRowClick(job))}>
                                                                <Tooltip message={job.job_type}>
                                                                    <span className="jobs-ellipsis-cell">
                                                                        {job.job_type}
                                                                    </span>
                                                                </Tooltip>
                                                            </td>
                                                            <td onClick={() => (activeTab === "sales" ? handleSalesRowClick(job) : handleCostRowClick(job))}>

                                                                <span
                                                                    className={`division-pill ${job.job_type_division === "scs" ? "scs" : "ff"
                                                                        } ${selectedBills.includes(job.id) ? "active" : ""}`}
                                                                >
                                                                    {job.job_type_division.toUpperCase()}
                                                                </span>
                                                            </td>
                                                            <td onClick={() => (activeTab === "sales" ? handleSalesRowClick(job) : handleCostRowClick(job))}>
                                                                <Tooltip message={job.project_name}>
                                                                    <span className="jobs-ellipsis-cell">
                                                                        {job.project_name}
                                                                    </span>
                                                                </Tooltip>
                                                            </td>
                                                            {activeTab === "cost" && (
                                                                <td
                                                                    onClick={() => handleCostRowClick(job)}
                                                                    style={{
                                                                        maxWidth: "180px",
                                                                        padding: "8px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    <Tooltip message={job.vendor_names}>
                                                                        <span
                                                                            style={{
                                                                                display: "block",
                                                                                maxWidth: "100%",
                                                                                overflow: "hidden",
                                                                                whiteSpace: "nowrap",
                                                                                textOverflow: "ellipsis",
                                                                            }}
                                                                        >
                                                                            {job.vendor_names}
                                                                        </span>
                                                                    </Tooltip>
                                                                </td>
                                                            )}
                                                            <td style={{ padding: '15px' }} onClick={() => (activeTab === "sales" ? handleSalesRowClick(job) : handleCostRowClick(job))}>
                                                                {activeTab === "sales" ? job.total_sales_amount : job.total_cost_amount}
                                                            </td>
                                                            <td onClick={() => (activeTab === "sales" ? handleSalesRowClick(job) : handleCostRowClick(job))}>
                                                                {job.modifieddate}
                                                            </td>

                                                            <td>
                                                                <button className={`status-button ${job.approval_status.toLowerCase()}`}>
                                                                    {formatStatus(job.approval_status)}
                                                                </button>
                                                            </td>
                                                        </tr>

                                                        {isExpanded && (activeTab === "cost" || activeTab === "sales") && (
                                                            <tr>
                                                                <td></td>
                                                                <td colSpan={9}>
                                                                    <div style={{
                                                                        background: '#fff',
                                                                        // padding: '10px',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '6px',
                                                                        overflowX: 'auto',

                                                                    }}>
                                                                        <table style={{ borderCollapse: 'collapse', width: '100%', margin: '0px' }}>
                                                                            <thead>
                                                                                <tr>
                                                                                    {activeTab === 'cost' && (
                                                                                        <th rowSpan="2" style={{ textAlign: 'center', backgroundColor: '#E0EFFF', }}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                onChange={(e) => {
                                                                                                    const isChecked = e.target.checked;
                                                                                                    const allIds = lineItemsData[job.id]?.map(item => item.job_cost_line_id).filter(Boolean) || [];

                                                                                                    setSelectedLineItems((prev) => ({
                                                                                                        ...prev,
                                                                                                        [job.id]: isChecked ? allIds : [],
                                                                                                    }));
                                                                                                }}
                                                                                                checked={
                                                                                                    lineItemsData[job.id] &&
                                                                                                    selectedLineItems[job.id]?.length ===
                                                                                                    lineItemsData[job.id]?.filter(item => item.job_cost_line_id != null).length
                                                                                                }
                                                                                            />
                                                                                        </th>
                                                                                    )}
                                                                                    {activeTab === 'sales' && (
                                                                                        <th rowSpan="2" style={{ textAlign: 'center', backgroundColor: '#D9FFE2', }}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                onChange={(e) => {
                                                                                                    const isChecked = e.target.checked;
                                                                                                    const allIds = lineItemsData[job.id]
                                                                                                        ?.filter(item => !item.is_pushed)
                                                                                                        .map(item => item.job_sales_line_id)
                                                                                                        .filter(Boolean) || [];

                                                                                                    setSelectedLineItems((prev) => ({
                                                                                                        ...prev,
                                                                                                        [job.id]: isChecked ? allIds : [],
                                                                                                    }));
                                                                                                }}
                                                                                                checked={
                                                                                                    lineItemsData[job.id] &&
                                                                                                    selectedLineItems[job.id]?.length ===
                                                                                                    lineItemsData[job.id]?.filter(item => item.job_sales_line_id != null && !item.is_pushed).length
                                                                                                }
                                                                                                disabled={allSalesItemsPushed}
                                                                                            />
                                                                                        </th>
                                                                                    )}


                                                                                    {activeTab === 'cost' && (
                                                                                        <th colSpan="14" style={{ textAlign: 'center', border: '1px solid #ccc', fontSize: '11px', backgroundColor: '#E0EFFF', color: '#097BED', }}>Cost</th>
                                                                                    )}
                                                                                    {activeTab === 'sales' && (
                                                                                        <th colSpan="11" style={{ textAlign: 'center', backgroundColor: '#D9FFE2', border: '1px solid #ccc', fontSize: '11px', color: '#008B1F' }}>Sales</th>
                                                                                    )}
                                                                                </tr>
                                                                                <tr>
                                                                                    {activeTab === 'cost' && (
                                                                                        <>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Charge Code</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Description</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Vendor</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Vendor Inv Number</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Vendor Inv Date</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>PO/WO No</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>PO/WO Date</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Remarks</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Accrual Split</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Contract Value</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Quantity</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Rate</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Net Total</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#E0EFFF', fontSize: '11px', textAlign: 'center' }}>Attachment</th>
                                                                                        </>
                                                                                    )}
                                                                                    {activeTab === 'sales' && (
                                                                                        <>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Charge Code</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Description</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>PO/WO No</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>PO/WO Date</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Remarks</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Accrual Split</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Contract Value</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Quantity</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Rate</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Net Total</th>
                                                                                            <th style={{ border: '1px solid #ccc', backgroundColor: '#D9FFE2', fontSize: '11px', textAlign: 'center' }}>Attachment</th>
                                                                                        </>
                                                                                    )}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {lineItemsData[job.id]?.map((item, itemIndex) => (
                                                                                    (activeTab === "cost" || activeTab === "sales") && (
                                                                                        <tr key={itemIndex}>
                                                                                            {activeTab === "cost" && (
                                                                                                <td style={{ textAlign: 'center' }}>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={selectedLineItems[job.id]?.includes(item.job_cost_line_id) || false}
                                                                                                        onChange={(e) => {
                                                                                                            const isChecked = e.target.checked;
                                                                                                            const itemId = item.job_cost_line_id;

                                                                                                            if (itemId == null) return;

                                                                                                            setSelectedLineItems((prev) => {
                                                                                                                const existing = prev[job.id] || [];
                                                                                                                const newItems = isChecked
                                                                                                                    ? [...existing, itemId]
                                                                                                                    : existing.filter((id) => id !== itemId);

                                                                                                                return {
                                                                                                                    ...prev,
                                                                                                                    [job.id]: newItems,
                                                                                                                };
                                                                                                            });
                                                                                                        }}
                                                                                                    />
                                                                                                </td>
                                                                                            )}

                                                                                            {activeTab === "sales" && (
                                                                                                <td style={{ textAlign: 'center' }}>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={selectedLineItems[job.id]?.includes(item.job_sales_line_id) || false}
                                                                                                        onChange={(e) => {
                                                                                                            const isChecked = e.target.checked;
                                                                                                            const itemId = item.job_sales_line_id;

                                                                                                            if (itemId == null) return;

                                                                                                            setSelectedLineItems((prev) => {
                                                                                                                const existing = prev[job.id] || [];
                                                                                                                const newItems = isChecked
                                                                                                                    ? [...existing, itemId]
                                                                                                                    : existing.filter((id) => id !== itemId);

                                                                                                                return {
                                                                                                                    ...prev,
                                                                                                                    [job.id]: newItems,
                                                                                                                };
                                                                                                            });
                                                                                                        }}
                                                                                                        disabled={item.is_pushed}
                                                                                                    />
                                                                                                </td>
                                                                                            )}

                                                                                            <td style={{ border: '1px solid #ccc' }}>{item.charge_code}</td>
                                                                                            <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.description}</td>

                                                                                            {activeTab === "cost" && (
                                                                                                <>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center', padding: '4px' }}>
                                                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                                                                                                            <span>{item.vendor_name}</span>
                                                                                                            <span
                                                                                                                onClick={() => setEditModal({
                                                                                                                    isOpen: true,
                                                                                                                    jobId: job.id,
                                                                                                                    lineItem: item
                                                                                                                })}
                                                                                                                title="Edit Vendor"
                                                                                                                style={{
                                                                                                                    width: '21px',
                                                                                                                    height: '21px',
                                                                                                                    borderRadius: '50%',
                                                                                                                    backgroundColor: '#ffffff',
                                                                                                                    border: '1px solid #ccc',
                                                                                                                    color: '#097BED',
                                                                                                                    display: 'flex',
                                                                                                                    alignItems: 'center',
                                                                                                                    justifyContent: 'center',
                                                                                                                    cursor: 'pointer',
                                                                                                                    transform: 'rotate(80deg)',
                                                                                                                    transition: 'background 0.2s, color 0.2s',
                                                                                                                }}
                                                                                                                onMouseOver={e => {
                                                                                                                    e.currentTarget.style.backgroundColor = '#097BED';
                                                                                                                    e.currentTarget.style.color = '#ffffff';
                                                                                                                }}
                                                                                                                onMouseOut={e => {
                                                                                                                    e.currentTarget.style.backgroundColor = '#ffffff';
                                                                                                                    e.currentTarget.style.color = '#097BED';
                                                                                                                }}
                                                                                                            >
                                                                                                                ✎
                                                                                                            </span>

                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.vendor_inv_number}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.vendor_inv_date}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_po_wo_number}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_po_wo_date}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_remarks}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_accrual}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_contract_value}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_unit_of_quantity}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_unit_of_rate}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.cost_net_total}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>
                                                                                                        {item.file_url ? (
                                                                                                            <a href={item.file_url} target="_blank" rel="noopener noreferrer">
                                                                                                                View
                                                                                                            </a>
                                                                                                        ) : 'None'}
                                                                                                    </td>
                                                                                                </>
                                                                                            )}

                                                                                            {editModal.isOpen && (
                                                                                                <div className="vendor-edit-modal">
                                                                                                    <div className="jobs-vendor-modal-content">
                                                                                                        <h3>Edit Vendor</h3>
                                                                                                        <div className="jobs-vendor-form-group">
                                                                                                            <label>Vendor</label>
                                                                                                            <AsyncSelect
                                                                                                                cacheOptions
                                                                                                                defaultOptions
                                                                                                                isClearable
                                                                                                                loadOptions={loadVendorOptions}
                                                                                                                value={editModal.lineItem.vendor_id ? {
                                                                                                                    label: editModal.lineItem.vendor_name,
                                                                                                                    value: editModal.lineItem.vendor_id
                                                                                                                } : null}
                                                                                                                styles={{
                                                                                                                    control: (base, state) => ({
                                                                                                                        ...base,
                                                                                                                        borderRadius: '12px',
                                                                                                                        fontSize: '14px',
                                                                                                                        width: '100%',
                                                                                                                        borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                                                                                                                        boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                                                                                        '&:hover': {
                                                                                                                            borderColor: '#454CF2'
                                                                                                                        },
                                                                                                                    }),
                                                                                                                    container: (base) => ({
                                                                                                                        ...base,
                                                                                                                        width: '100%'
                                                                                                                    }),
                                                                                                                    menu: (base) => ({
                                                                                                                        ...base,
                                                                                                                        zIndex: 999,
                                                                                                                        fontSize: '13px',
                                                                                                                        marginTop: '4px',
                                                                                                                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                                                                                    }),
                                                                                                                    option: (base, { isFocused }) => ({
                                                                                                                        ...base,
                                                                                                                        backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                                                                                                                        color: '#333',
                                                                                                                        padding: '10px',
                                                                                                                        cursor: 'pointer',
                                                                                                                        borderBottom: '1px solid #eee',
                                                                                                                        '&:active': {
                                                                                                                            backgroundColor: '#f2f2f2'
                                                                                                                        }
                                                                                                                    })
                                                                                                                }}
                                                                                                                onChange={(selected) => {
                                                                                                                    setEditModal(prev => ({
                                                                                                                        ...prev,
                                                                                                                        lineItem: {
                                                                                                                            ...prev.lineItem,
                                                                                                                            vendor_id: selected ? selected.value : null,
                                                                                                                            vendor_name: selected ? selected.label : ''
                                                                                                                        }
                                                                                                                    }));
                                                                                                                }}

                                                                                                                placeholder="Select Vendor"
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="jobs-vendor-modal-actions">
                                                                                                            <button
                                                                                                                className="cancel-btn"
                                                                                                                onClick={() => setEditModal({ isOpen: false, jobId: null, lineItem: null })}
                                                                                                            >
                                                                                                                Cancel
                                                                                                            </button>
                                                                                                            <button
                                                                                                                className="save-btn"
                                                                                                                onClick={async () => {
                                                                                                                    try {
                                                                                                                        const jobLineId = editModal.lineItem.job_cost_line_id

                                                                                                                        if (!jobLineId) {
                                                                                                                            toast.error("Job line ID is missing");
                                                                                                                            return;
                                                                                                                        }

                                                                                                                        const response = await axiosInstance.post('/job/jobline_vendor_update', {
                                                                                                                            job_cost_line_id: jobLineId,
                                                                                                                            vendor_id: editModal.lineItem.vendor_id
                                                                                                                        });

                                                                                                                        if (response.data.success) {
                                                                                                                            setLineItemsData(prev => {
                                                                                                                                const updatedItems = [...prev[editModal.jobId]];
                                                                                                                                const itemIndex = updatedItems.findIndex(
                                                                                                                                    i => i.job_cost_line_id === jobLineId
                                                                                                                                );

                                                                                                                                if (itemIndex !== -1) {
                                                                                                                                    updatedItems[itemIndex] = {
                                                                                                                                        ...updatedItems[itemIndex],
                                                                                                                                        vendor_id: editModal.lineItem.vendor_id,
                                                                                                                                        vendor_name: editModal.lineItem.vendor_name
                                                                                                                                    };
                                                                                                                                }

                                                                                                                                return {
                                                                                                                                    ...prev,
                                                                                                                                    [editModal.jobId]: updatedItems
                                                                                                                                };
                                                                                                                            });

                                                                                                                            await fetchLineItems(editModal.jobId);
                                                                                                                            toast.success("Vendor updated successfully");
                                                                                                                            setEditModal({ isOpen: false, jobId: null, lineItem: null });
                                                                                                                        }
                                                                                                                    } catch (error) {
                                                                                                                        console.error("Vendor update error:", error);
                                                                                                                        toast.error("Failed to update vendor");
                                                                                                                    }
                                                                                                                }}
                                                                                                            >
                                                                                                                Save Changes
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {activeTab === "sales" && (
                                                                                                <>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_po_wo_number}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_po_wo_date}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_remarks}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_accrual}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_contract_value}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_unit_of_quantity}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_unit_of_rate}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>{item.sales_net_total}</td>
                                                                                                    <td style={{ border: '1px solid #ccc', fontSize: '11px', textAlign: 'center' }}>
                                                                                                        {item.file_url ? (
                                                                                                            <a href={item.file_url} target="_blank" rel="noopener noreferrer">
                                                                                                                View Attachment
                                                                                                            </a>
                                                                                                        ) : 'No Attachment'}
                                                                                                    </td>

                                                                                                </>
                                                                                            )}

                                                                                        </tr>

                                                                                    )
                                                                                ))}
                                                                            </tbody>

                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })) : isInitialJobsLoading ? (
                                                <tr>
                                                    <td colSpan={activeTab === "cost" ? 11 : 10} style={{ textAlign: "center", padding: "30px" }}>
                                                        <div className="dot-loader">
                                                            <span></span>
                                                            <span></span>
                                                            <span></span>
                                                        </div>
                                                        <p style={{ marginTop: "6px", fontSize: "13px", color: "#666" }}>
                                                            Loading jobs...
                                                        </p>
                                                    </td>
                                                </tr>
                                            ) : (
                                            <tr>
                                                <td colSpan={activeTab === "cost" ? 11 : 10} style={{ textAlign: "center", padding: "20px", fontSize: "14px" }}>
                                                    {searchTerm ? `No jobs found matching "${searchTerm}"` : "No jobs found"}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </>
                    ) : (
                        <div className='jobs-table' style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                            {activeTab === "draft" && (
                                <div className="records-pill">
                                    Total Records:<span className="records-pill-sales">{statusCounts?.draft || 0}</span>
                                </div>
                            )}

                            {activeTab === "submitted" && (
                                <div className="records-pill">
                                    Total Records:<span className="records-pill-sales">{statusCounts?.submitted || 0}</span>
                                </div>
                            )}
                            <table>
                                <thead>
                                    <tr style={{
                                        width: "60px",
                                        minWidth: "60px",
                                        textAlign: "center",
                                        padding: "4px"
                                    }}>
                                        {(activeTab === "draft") && (
                                            <th style={{
                                                width: "60px",
                                                minWidth: "60px",
                                                textAlign: "center",
                                                padding: "4px"
                                            }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedDraftJobs.length === filteredJobs.length && filteredJobs.length > 0}
                                                    onChange={handleSelectAllDrafts}
                                                />
                                            </th>
                                        )}
                                        {(activeTab === "submitted") && (
                                            <th style={{
                                                width: "60px",
                                                minWidth: "60px",
                                                textAlign: "center",
                                                padding: "4px"
                                            }}>S.No</th>
                                        )}
                                        <th>Job No</th>
                                        <th>Supply Period</th>
                                        <th>Job Type</th>
                                        <th>Job Type Division</th>
                                        <th>Project</th>
                                        <th>Sales Amt</th>
                                        <th>Cost Amt</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th style={{ width: "40px" }}></th> {/* Empty header for delete icon */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredJobs.length > 0 ? (
                                        filteredJobs.map((jobs, index) => (
                                            <tr key={index} className="table-row"
                                                style={{ cursor: 'pointer' }}>
                                                {(activeTab === "draft") && (
                                                    <td style={{
                                                        width: "60px",
                                                        minWidth: "60px",
                                                        textAlign: "center",
                                                        padding: "4px"
                                                    }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDraftJobs.includes(jobs.id)}
                                                            onChange={() => handleDraftCheckboxChange(jobs.id)}
                                                        />
                                                    </td>
                                                )}
                                                {(activeTab === "submitted") && (
                                                    <td style={{
                                                        width: "60px",
                                                        minWidth: "60px",
                                                        textAlign: "center",
                                                        padding: "4px"
                                                    }}>{skip + index + 1}</td>
                                                )}
                                                <td onClick={() => handleRowClick(jobs)}>{jobs.job_number}</td>
                                                <td onClick={() => handleRowClick(jobs)}>
                                                    {jobs.supply_period && (
                                                        <span className="supply-period-pill">
                                                            <svg viewBox="0 0 24 24" fill="currentColor">
                                                                <path d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1zm12 8H5v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8z" />
                                                            </svg>
                                                            {jobs.supply_period}
                                                        </span>
                                                    )}
                                                </td>
                                                <td onClick={() => handleRowClick(jobs)}>
                                                    <Tooltip message={jobs.job_type}>
                                                        <span className="jobs-ellipsis-cell">
                                                            {jobs.job_type}
                                                        </span>
                                                    </Tooltip>
                                                </td>
                                                <td onClick={() => handleRowClick(jobs)}>
                                                    <span
                                                        className={`division-pill ${jobs.job_type_division === "scs" ? "scs" : "ff"
                                                            } ${selectedDraftJobs.includes(jobs.id) ? "active" : ""}`}
                                                    >
                                                        {jobs.job_type_division.toUpperCase()}
                                                    </span>
                                                </td>
                                                <td onClick={() => handleRowClick(jobs)}>
                                                    <Tooltip message={jobs.project_name}>
                                                        <span className="jobs-ellipsis-cell">
                                                            {jobs.project_name}
                                                        </span>
                                                    </Tooltip>
                                                </td>
                                                <td onClick={() => handleRowClick(jobs)}>{jobs.total_sales_amount}</td>
                                                <td onClick={() => handleRowClick(jobs)}>{jobs.total_cost_amount}</td>
                                                <td onClick={() => handleRowClick(jobs)}>{jobs.modifieddate}</td>
                                                <td>
                                                    <button className={`status-button ${(activeTab).toLowerCase()}`}>
                                                        {formatStatus(jobs.approval_status)}
                                                    </button>
                                                </td>
                                                {/* <td className="delete-cell">
                                    <button className="delete-icon-button" onClick={() => handleDeleteRow(jobs.jobNo)}  >
                                     <img src={delete_icon} alt='' /> 
                                     </button>
                                </td> */}
                                                <td>
                                                    {(activeTab === "draft") && (
                                                        <div className="actions">

                                                            <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                                                                <span className="edit-icon"
                                                                    style={{ cursor: 'pointer' }}><img src={Vector} onClick={() => handleEditClick(jobs.id)} alt="Edit Icon" width="20" height="20" />
                                                                </span>
                                                            </PermissionWrapper>

                                                            <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                                                                <span className="delete-icon">
                                                                    <img src={Delete} alt="Delete Icon" onClick={() => handleDelete(jobs.id)} width="40" height="40" />
                                                                </span>
                                                            </PermissionWrapper>

                                                        </div>
                                                    )}
                                                    {(userType === 'SA' || userType === 'A') &&
                                                        activeTab === "submitted" &&
                                                        jobs.approval_status === "submitted" &&
                                                        jobs.job_created_type === "manual" && (
                                                            <div className="actions">
                                                                <span
                                                                    className="revert-icon-wrapper"
                                                                    onClick={() => handleRevertClick(jobs.id)}
                                                                >
                                                                    <img
                                                                        src={revert_icon}
                                                                        alt="Revert Icon"
                                                                        className="revert-icon-img"
                                                                        width="20"
                                                                        height="20"
                                                                    />
                                                                </span>
                                                                <span></span>
                                                                <span></span>
                                                            </div>
                                                        )}


                                                </td>
                                            </tr>
                                        ))) : isInitialJobsLoading ? (
                                            <tr>
                                                <td colSpan={activeTab === "draft" ? 11 : 10} style={{ textAlign: "center", padding: "30px" }}>
                                                    <div className="dot-loader">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                    <p style={{ marginTop: "6px", fontSize: "13px", color: "#666" }}>
                                                        Loading jobs...
                                                    </p>
                                                </td>
                                            </tr>
                                        ) : (
                                        <tr>
                                            <td colSpan={activeTab === "draft" ? 11 : 10} style={{ textAlign: "center", padding: "20px", fontSize: "14px" }}>
                                                {searchTerm ? `No jobs found matching "${searchTerm}"` : "No jobs found"}
                                            </td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* <div className="jobs-pagination-container d-flex align-items-center justify-content-between mt-3">
                        <div className="Limit-Dropdown">
                            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
                            <select
                                id="limit"
                                value={limit}
                                onChange={handleLimitChange}
                                className="jobs-form-select d-inline w-auto">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </select>
                        </div>

                        <div className="react-page d-flex align-items-center gap-4">
                            <ReactPaginate
                                previousLabel="Previous"
                                nextLabel="Next"
                                pageCount={totalPages}
                                onPageChange={handlePageClick}
                                forcePage={currentPage}
                                containerClassName="pagination"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                activeClassName="active"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={3}
                                disabledClassName="disabled"
                            />
                        </div>
                    </div> */}
                    <CommonPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        limit={limit}
                        onPageChange={handlePageClick}
                        onLimitChange={handleLimitChange}
                    />
                </div>
            )}
            <CommonFooter />
            <ConfirmDialog
                open={confirmOpen}
                title="Delete Confirmation"
                message="Are you sure you want to delete this job?"
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={confirmDelete}
                onCancel={cancelDelete}
            />
            <ConfirmDialog
                open={confirmSalesOpen}
                title="Generate Sales Invoice"
                message={`Are you sure you want to generate ${selectedDraftJobs.length} selected jobs?`}
                confirmText="Generate"
                cancelText="Cancel"
                onConfirm={confirmDraftToSalesInvoice}
                onCancel={cancelDraftToSalesInvoice}
            />
            <ConfirmDialog
                open={confirmBulkSubmitOpen}
                title="Bulk Submit Jobs"
                message={`Are you sure you want to submit ${selectedDraftJobs.length} selected jobs?`}
                confirmText="Submit"
                cancelText="Cancel"
                onConfirm={confirmBulkSubmit}
                onCancel={cancelBulkSubmit}
            />
            <ConfirmDialog
                open={confirmBulkDeleteOpen}
                title="Bulk Delete Jobs"
                message={`Are you sure you want to delete ${selectedDraftJobs.length} selected jobs?`}
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={confirmBulkDelete}
                onCancel={cancelBulkDelete}
            />
            <ConfirmDialog
                open={confirmRevertOpen}
                title="Revert Job"
                message="Are you sure you want to revert this job?"
                confirmText="Revert"
                cancelText="Cancel"
                onConfirm={confirmRevert}
                onCancel={cancelRevert}
            />
            <DraftCostInvoiceModal
                isOpen={showDraftCostInvoiceModal}
                onClose={() => {
                    setShowDraftCostInvoiceModal(false);
                    setInvoiceType("");
                }}
                invoiceType={invoiceType}
                setInvoiceType={setInvoiceType}
                selectedJobsCount={selectedDraftJobs.length}
                onGenerate={() => {
                    setShowDraftCostInvoiceModal(false);
                    confirmDraftToCostInvoice(invoiceType);
                    setInvoiceType("");
                }}
                onCancel={() => {
                    setShowDraftCostInvoiceModal(false);
                    setInvoiceType("");
                }}
            />
            {/* Charge Type Modal */}
            <GenerateCostInvoiceModal
                isOpen={showChargeTypeModal}
                onClose={() => setShowChargeTypeModal(false)}
                invoiceType={invoiceType}
                setInvoiceType={setInvoiceType}
                onSubmit={handleGenerateBill}
            />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    )
}

export default Jobs;